import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { SabreText } from '@shared/components/sabre-text-dialog/models/sabre-text';
import { AlertService } from '@shared/services/alert/alert.service';
import { RequestState } from '../../models/request-state';
import { FieldConditionService } from './field-condition.service';
import { FieldConditionResponse } from './models/field-condition.response';

@Injectable({
  providedIn: 'root',
})
export class FieldConditionStore {
  // Arrow function required to bind 'this' properly.
  refreshFn = (airport: string) => this.refreshFieldCondition(airport);

  constructor(
    private fieldConditionService: FieldConditionService,
    private alertService: AlertService,
  ) {}

  getFieldCondition(airport: string): Observable<RequestState<SabreText>> {
    return this.fieldConditionService.getFieldCondition(airport).pipe(
      map((requestState) => {
        return this.mapResponse(requestState);
      }),
    );
  }

  refreshFieldCondition(airport: string): Observable<RequestState<SabreText>> {
    return this.fieldConditionService.refreshFieldCondition(airport).pipe(
      map((requestState) => {
        return this.mapResponse(requestState);
      }),
    );
  }

  // eslint-disable-next-line complexity
  mapResponse(
    requestState: RequestState<FieldConditionResponse>,
  ): RequestState<SabreText> {
    if (requestState.hasError) {
      this.showErrorAlert();
    }

    if (!requestState.response) {
      return requestState.into<SabreText>();
    }

    const text = requestState.response.raw;
    const sabreText = new SabreText(text, requestState.response.timestamp);

    // Split text into lines array and mark which lines contain 'code' or 'combo' to highlight door codes.
    for (const line of sabreText.lines) {
      if (
        line.text.includes('CODE') ||
        line.text.includes('COMBO') ||
        line.text.includes('COMBINATION') ||
        line.text.includes('KEYPAD') ||
        line.text.includes('JETBRDG DC') ||
        line.text.includes('RAMP TO BDG')
      ) {
        line.classes = ['highlight'];
      }
    }

    return requestState.into<SabreText>(sabreText);
  }

  private showErrorAlert(): void {
    this.alertService.setAlert({
      type: 'error',
      message: 'Unable to load field condition report.',
    });
  }
}
